module.exports = __webpack_public_path__ + "media/application/images/icons/innovations/level-low-a39fd3cfce6cac021b59a9a45e7a29c3.svg";